import { observable, action, makeAutoObservable, runInAction } from "mobx";
import { message, notification } from "antd";
import { persist } from 'mobx-persist';
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";

class UserStore {

    @observable loading = false;
    @observable isSuccess = false;

    @observable perPage = 10;
    @observable hasMore = false;
    @observable page = 1;

    @observable users = [];
    @observable userLoads = [];
    @observable teamLeaders = [];
    @observable admins = [];
    @observable userLoadsItems = [];
    @observable userLoadsCash = [];

    @observable loguser = {};
    @observable user = {};
    @observable userLoad = {};
    @observable teamLeader = {};
    @observable admin = {};
    
    @persist @observable loginStatus = false;
    @persist @observable userID = '';
    @persist @observable username = '';
    @persist @observable fullName = '';
    @persist @observable address = '';
    @persist @observable contactNumber = '';
    @persist @observable userType = '';
    @persist @observable amount = '';
    @persist @observable itemAmount = '';
    @persist @observable totalAmount = '';
    @persist @observable totalAmountReload = '';
    @persist @observable metadata = '';

    //TOKENS
    @persist @observable accessToken = '';

    constructor() {
        makeAutoObservable(this);
    }

    @action
    createNewTeamLeader = async (values) => {
        
        this.loading = true;
        
        try {
            const response = await axios.post(`/users/create_teamleader.php`, values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'New District Coordinator Added'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "New District Coordinator Added",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        //REDIRECT TO THE LIST OF TEAM LEADERS
                        setTimeout(function() {
                            window.location.reload();
                        }, 500);
                    } 
                })
            }

        } catch (error) {
            console.log(error.response.data);
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'User Registration Error',
                    description: error.response.data.message
                });
                message.error('User Registration Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
                
            });
        }
    }

    @action
    createNewAdmin = async (values) => {
        
        this.loading = true;
        
        try {
            const response = await axios.post(`/users/create_admin.php`, values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'New Admin Added'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "New Admin Added",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        //REDIRECT TO THE LIST OF TEAM LEADERS
                        setTimeout(function() {
                            window.location.reload();
                        }, 500);
                    } 
                })
            }

        } catch (error) {
            console.log(error.response.data);
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'User Registration Error',
                    description: error.response.data.message
                });
                message.error('User Registration Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
                
            });
        }
    }

    @action
    login = async ({ username, password }) => {
        
        this.loading = true;

        const datapost = {
            username: username,
            password: password,
        };
        
        try {
            //EXAMPLE CODE IF WE NEED TO USE ACCESS_TOKEN FOR CRUD
            // const response = await axios.post(`/users/login.php`, datapost, {
            //     headers: {
            //         'Content-Type': 'application/json',
            //         'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
            //     }
            // });
            const response = await axios.post(`/users/login.php`, datapost);

            if (response.status === 200) {

                let user = response.data.data.user;

                console.log(user);
               
                runInAction(() => {
                    this.loginStatus = true;
                    this.metadata = user.permissions
                    this.username = user.username;
                    this.fullName  = user.fullName;
                    this.address  = user.address;
                    this.contactNumber  = user.contactNumber;
                    this.userType  = user.userType;
                    this.amount  = user.amount;
                    this.itemAmount = user.itemAmount;
                    this.totalAmount  = user.totalAmount;
                    this.totalAmountReload  = user.totalAmountReload;
                    this.userID = user.userID;
                    this.isActive = user.isActive;
                    this.accessToken = response.data.data.accessToken;
                });

                //QUNDRVNTX1RPS0VO is Base64 for ACCESS_TOKEN
                localStorage.setItem("QUNDRVNTX1RPS0VO", this.accessToken);

                notification.success({
                    top: 120,
                    message: 'Success!',
                    description: 'User Logged In Successfully.'
                });

                Swal.fire({
                    title: "Welcome",
                    icon: "success",
                    text: "User Logged In Successfully!",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    
                    if (result.isConfirmed) {
                        //CHECK USERTYPE FIRST BEFORE REDIRECT
                        setTimeout(function() {
                            if (user.userType == 'SUPERADMIN'){
                                window.location.replace('/team-leaders');
                            } else if(user.userType == 'ADMIN') {
                                window.location.replace('/team-leaders');
                            } else {
                                window.location.replace('/voters');
                            }
                        }, 500);
                    } 
                })

            }
        } catch (error) {
           
            if(error.code === "ERR_NETWORK"){
                notification.error({
                    top: 120,
                    message: 'User Login Error',
                    description: error.message
                });
                message.error('User Login Error');
            } else{
                if(error.response.data){
                    notification.error({
                        top: 120,
                        message: 'User Login Error',
                        description: error.response.data.message
                    });
                    message.error('User Login Error');
                }
            }
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    }


    @action
    refetchUser = async () => {

        this.loading = true;
        
        try {
            const response = await axios.get(`/users/refetch_user.php`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.loguser = response.data.data;
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Refetch User Error',
                    description: error.response.data.message
                });
                message.error('Refetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

   

    @action
    fetchUsersTeamLeaders = async (userType) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/users/get_all_teamleaders.php?userType=${userType}&perPage=${this.perPage}&page=${this.page}&sortBy=ASC`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.teamLeaders = response.data.data;
                        if (this.teamLeaders && this.teamLeaders.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Users Error',
                    description: error.response.data.message
                });
                message.error('Fetching Users Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    fetchUsersAdmins = async (userType) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/users/get_all_teamleaders.php?userType=${userType}&perPage=${this.perPage}&page=${this.page}&sortBy=ASC`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.admins = response.data.data;
                        if (this.admins && this.admins.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Users Error',
                    description: error.response.data.message
                });
                message.error('Fetching Users Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    fetchUserByID = async (id) => {

        this.loading = true;
        
        try {
            const response = await axios.get(`/users/get_user.php?id=${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.teamLeader = response.data.data;
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetch User Error',
                    description: error.response.data.message
                });
                message.error('Fetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    fetchUserLoadsTeamLeader = async (id) => {

        this.loading = true;
        
        try {
            const response = await axios.get(`/userloads/get_all_userloads_teamleader.php?teamLeaderID=${id}&perPage=${this.perPage}&page=${this.page}&sortBy=DESC&orderBy=CreatedAt`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.userLoads = response.data.data;
                        if (this.userLoads && this.userLoads.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetch User Error',
                    description: error.response.data.message
                });
                message.error('Fetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    fetchUserLoadsTeamLeaderStatus = async (id) => {

        this.loading = true;

        const status = 'PENDING';
        
        try {
            const response = await axios.get(`/userloads/get_all_userloads_teamleader_status.php?teamLeaderID=${id}&status=${status}&perPage=${this.perPage}&page=${this.page}&sortBy=DESC&orderBy=CreatedAt`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {

                    if (response.data) {

                        this.userLoads = response.data.data;

                        // Separate data into ITEM and CASH collections
                        const { items, cash } = this.separateUserLoads(response.data.data);
                        this.userLoadsItems = items; // Save ITEM type data
                        this.userLoadsCash = cash;   // Save CASH type data
    
                        // Check if there's more data to load
                        if ((items.length + cash.length) < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetch User Error',
                    description: error.response.data.message
                });
                message.error('Fetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    resetPassword = async (id) => {

        this.loading = true;

        const data = {
            userID: id
        }
        
        try {
            const response = await axios.patch(`/users/reset_password.php`, data , {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                runInAction(() => {
                    if(response.data){
                        this.isSuccess = true;
                    }
                });

                notification.success({
                    top: 120,
                    message: 'Password Reset',
                    description: 'Password Successfully Reset'
                });

                Swal.fire({
                    title: "Success!",
                    text: "Password Successfully Reset.",
                    icon: "success",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                })
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Password Reset Value Error',
                    description: error.response.data.message
                });
                message.error('Password Reset Value Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
            });
        }
    }

    @action
    markAsOpposition = async (record) => {

        this.loading = true;

        const data = {
            votersID: record.VIN,
            fullName: record.FullName,
            address: record.Address,
            contactNumber: record.MobileNo,
        }
        
        try {
            const response = await axios.post(`/users/mark_as_opposition.php`, data , {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                notification.success({
                    top: 120,
                    message: 'Voter mark as Opposition',
                    description: 'New Voter Opposition Added'
                });

                Swal.fire({
                    title: "Success!",
                    icon: "success",
                    text: "New Voter Opposition Added",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        setTimeout(function() {
                            window.location.reload();
                        }, 500);
                    } 
                })
            }

        } catch (error) {
            console.log(error.response.data);
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Voter mark as Opposition Error',
                    description: error.response.data.message
                });
                message.error('Voter mark as Opposition Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
                
            });
        }
    }

    @action
    markAsUndecided = async (record) => {

        this.loading = true;

        const data = {
            votersID: record.VIN,
            fullName: record.FullName,
            address: record.Address,
            contactNumber: record.MobileNo,
        }
        
        try {
            const response = await axios.post(`/users/mark_as_undecided.php`, data , {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                notification.success({
                    top: 120,
                    message: 'Voter mark as Undecided',
                    description: 'New Voter Undecided Added'
                });

                Swal.fire({
                    title: "Success!",
                    icon: "success",
                    text: "New Voter Undecided Added",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        setTimeout(function() {
                            window.location.reload();
                        }, 500);
                    } 
                })
            }

        } catch (error) {
            console.log(error.response.data);
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Voter mark as Undecided Error',
                    description: error.response.data.message
                });
                message.error('Voter mark as Undecided Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
                
            });
        }
    }

    @action
    deleteTeamLeader = async (id) => {

        this.loading = true;
        
        try {

            const response = await axios({
                method: 'patch',
                url: `/users/delete_teamleader.php?id=${id}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });


            if (response.status === 201) {
                runInAction(() => {
                    if(response.data){
                        this.isSuccess = true;
                    }
                });

                notification.success({
                    top: 120,
                    message: 'User Deleted!',
                    description: 'District Coordinator Successfully Deleted!'
                });

                Swal.fire({
                    title: "User Deleted!",
                    icon: "success",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                })
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'District Coordinator Delete Error',
                    description: error.response.data.message
                });
                message.error('District Coordinator Delete Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
            });
        }
    }

    @action
    searchTeamLeader = async (name) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/users/search_teamleader.php?name=${name}&perPage=${this.perPage}&page=${this.page}&sortBy=ASC&orderBy=CreatedAt`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.teamLeaders = response.data.data;
                        if (this.teamLeaders && this.teamLeaders.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }

                        notification.success({
                            top: 120,
                            message: 'Done!',
                            description: 'Search District Coordinator Successful.'
                        });

                    }
                });
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching District Coordinator Error',
                    description: error.response.data.message
                });
                message.error('Fetching District Coordinator Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    topupTeamLeaders = async (values) => {
        
        this.loading = true;

        const datapost = {
            topups: values
        }
        
        try {
            const response = await axios.post(`/users/topup_teamleaders.php`, datapost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'Fund Allocation Successful'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "Fund Allocation Successful",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        localStorage.removeItem('topUpItemTeamLeaders');
                        localStorage.removeItem('topUpCashTeamLeaders');

                        //REDIRECT TO THE TOP UP TEAM LEADERS
                        setTimeout(function() {
                            window.location.reload();
                        }, 500);
                    } 
                })
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Top Up District Coordinator Failure.',
                    description: error.response.data.message
                });
                message.error('Top Up District Coordinator Failure.');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    topupTeamLeaderVoterItem = async (values, id) => {
        
        this.loading = true;

        const datapost = {
            topups: values
        }
        
        try {
            const response = await axios.post(`/users/topup_teamleaders_voter_item.php`, datapost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'Top Up Voter Successful'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "Top Up Voter Successful",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        localStorage.removeItem(`adminayudaitem_${id}`);

                        //REDIRECT TO THE TOP UP TEAM LEADERS
                        setTimeout(function() {
                            window.location.reload();
                        }, 500);
                    } 
                })
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Top Up District Coordinator Failure.',
                    description: error.response.data.message
                });
                message.error('Top Up District Coordinator Failure.');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    updateTeamLeader = async (values, id) => {
        
        this.loading = true;

        const datapost = {
            fullName: values.FullName,
            address: values.Address,
            contactNumber: values.ContactNumber,
            remarks: values.Remarks,
        }
        
        try {
            const response = await axios.patch(`/users/update_teamleader.php?id=${id}`, datapost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'District Coordinator Updated'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "District Coordinator Updated",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                })
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Edit District Coordinator Failure.',
                    description: error.response.data.message
                });
                message.error('Edit District Coordinator Failure.');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    updateAdmin = async (values, id) => {
        
        this.loading = true;

        const datapost = {
            fullName: values.FullName,
            address: values.Address,
            contactNumber: values.ContactNumber,
            remarks: values.Remarks,
        }
        
        try {
            const response = await axios.patch(`/users/update_teamleader.php?id=${id}`, datapost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'Admin Updated'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "Admin Updated",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                })
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Edit Admin Failure.',
                    description: error.response.data.message
                });
                message.error('Edit Admin Failure.');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    updateAdminPermissions = async (values, id) => {
        
        this.loading = true;

        const permissions = {
            hasAddClusterLeader: values.addClusterLeaderCB === true ? "true" : "false", 
            hasfundAllocation: values.fundAllocationCB === true ? "true" : "false", 
            hasEvents: values.eventsCB === true ? "true" : "false",
            hasOrganization: values.organizationCB === true ? "true" : "false"
        }

        const defaultstring = JSON.stringify(permissions);
        const defaultmetadata = btoa(defaultstring);

        const datapost = {
            metadata: defaultmetadata
        }
        
        try {
            const response = await axios.patch(`/users/update_admin_permissions.php?id=${id}`, datapost, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 201) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'Admin Permissions Updated'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "Admin Permissions Updated",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                })
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Edit Admin Failure.',
                    description: error.response.data.message
                });
                message.error('Edit Admin Failure.');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }


    // ----------------------------------------------
    // Function to separate data into ITEM and CASH collections
    separateUserLoads = (data) => {
        const items = [];
        const cash = [];

        data.forEach(item => {
            if (item.Type === 'ITEM') {
                items.push(item);
            } else if (item.Type === 'CASH') {
                cash.push(item);
            }
        });

        return { items, cash };
    }
    
}


export default UserStore;

//EXAMPLE CODE IF WE NEED TO USE A NON ASYNC AXIOS FUNCTION 
// axios
//     .post(`/users/login.php`, datapost)
//     .then((response) => {
//         if (response.status === 200) {
//             let user = response.data.data.user;

//             this.username = user.username;
//             this.name  = user.name;
//             this.address  = user.address;
//             this.mobileNumber  = user.mobileNumber;
//             this.referrer  = user.referrer;
//             this.userType  = user.userType;
//             this.address  = user.address;
//             this.groupAccount  = user.groupAccount;
//             this.isLoggedIn  = user.isLoggedIn;
//             this.accessToken = response.data.data.accessToken;
//             //QUNDRVNTX1RPS0VO is Base64 for ACCESS_TOKEN
//             localStorage.setItem("QUNDRVNTX1RPS0VO", this.accessToken);

//             const persistAccessToken = btoa('ACCESS_TOKEN');
//             axios.defaults.headers = {
//                 Authorization: `Bearer ${localStorage.getItem(persistAccessToken)}`,
//             };
//         }
//     })
//     .catch((error) => {
//         console.log(error);
//     })
//     .finally(() => {
//         this.loading = false;
//     });